module.exports = __webpack_public_path__ + "img/notification.47d0acd6.svg";